module.exports = __webpack_public_path__ + "img/movie5.c75c5876.png";